module.exports = __webpack_public_path__ + "static/mother-holding-her-child.c562e40a.webp";